import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d6u4vmi9puk3bj9673sg';

export default function AIAvatarLeadForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="ai-avatar-form" className="py-14 sm:py-28 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Top CTA quote */}
        <div className="bg-gradient-to-br from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl p-6 sm:p-10 mb-6 sm:mb-12 text-center">
          <p className="text-sm sm:text-xl text-white/90 font-['Playfair_Display'] font-bold leading-relaxed max-w-4xl mx-auto mb-4 sm:mb-5">
            Видео занимает до 90% всего интернет-трафика. Люди предпочитают смотреть, а не читать. С ИИ-аватаром вы занимаете лидирующую позицию в своей нише, пока конкуренты только собираются на съёмки.
          </p>
          <p className="text-[#C5A880] font-['Montserrat'] font-semibold text-sm sm:text-base">
            Начните использовать технологии будущего сегодня.
          </p>
        </div>

        {/* Main card */}
        <div className="bg-gradient-to-br from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">

            {/* LEFT — Photo + Info */}
            <div className="lg:w-[42%] flex flex-col items-center justify-center p-6 sm:p-10 lg:p-14 bg-white/05 border-b lg:border-b-0 lg:border-r border-white/10">
              <div className="w-40 sm:w-52 lg:w-64 rounded-2xl overflow-hidden mb-4 sm:mb-5 flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/bc89a6f73ddaed1a26846899a6dde312.png"
                  alt="Ирина Шарова-Ялынпала — Эксперт по нейро-технологиям"
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="text-center">
                <p className="text-white font-bold text-base sm:text-lg font-['Playfair_Display'] leading-snug mb-1">
                  Ирина Шарова-Ялынпала
                </p>
                <p className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] mb-2">
                  Ваш эксперт по нейро-технологиям
                </p>
                <p className="text-[#C5A880]/80 text-xs font-['Montserrat'] mb-3">
                  Маркетолог-стратег
                </p>
                <p className="text-white/70 text-sm font-['Montserrat'] leading-relaxed text-center max-w-xs">
                  Масштабирую ваш личный бренд с помощью системного подхода и Искусственного Интеллекта.
                </p>
              </div>
            </div>

            {/* RIGHT — Form */}
            <div className="w-full lg:w-[58%] p-5 sm:p-10 lg:p-14">
              <div className="mb-5 sm:mb-8">
                <div className="inline-flex items-center gap-2 bg-[#C5A880]/30 border border-[#C5A880]/50 px-4 py-2 rounded-full text-xs font-semibold text-[#FFE0A8] mb-4 font-['Montserrat']">
                  <i className="ri-robot-2-line"></i>
                  Консультация по ИИ-аватарам
                </div>
                <h3 className="text-lg sm:text-3xl font-['Playfair_Display'] font-bold text-white mb-3 leading-tight">
                  Записаться на консультацию по ИИ-аватарам
                </h3>
                <p className="text-xs sm:text-sm text-white/60 leading-relaxed font-['Montserrat']">
                  Расскажите о вашем бизнесе — рассчитаем окупаемость ИИ-аватара именно для вашей ниши и покажем первые результаты.
                </p>
              </div>

              {status === 'success' ? (
                <div className="text-center py-10">
                  <div className="w-16 h-16 bg-[#C5A880]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-[#C5A880] text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white font-['Playfair_Display'] mb-2">
                    Заявка отправлена!
                  </h3>
                  <p className="text-white/60 text-sm font-['Montserrat']">
                    Мы свяжемся с вами в течение 24 часов.
                  </p>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Ваше имя *
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="Иван Иванов"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="ivan@company.ru"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Телефон
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+7 (000) 000-00-00"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Сфера деятельности
                      </label>
                      <select
                        name="business_type"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors appearance-none cursor-pointer"
                      >
                        <option value="" className="text-gray-800">Выберите тип</option>
                        <option value="expert" className="text-gray-800">Эксперт / Блогер</option>
                        <option value="school" className="text-gray-800">Онлайн-школа</option>
                        <option value="business" className="text-gray-800">Бизнес / E-commerce</option>
                        <option value="hr" className="text-gray-800">HR / Корпоративное обучение</option>
                        <option value="other" className="text-gray-800">Другое</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                      Расскажите о вашей задаче
                    </label>
                    <textarea
                      name="message"
                      rows={3}
                      maxLength={500}
                      placeholder="Какой контент хотите создавать? Для какой аудитории? Какие языки важны?"
                      className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors resize-none"
                    />
                  </div>

                  {status === 'error' && (
                    <p className="text-red-400 text-xs font-['Montserrat'] text-center">
                      Ошибка при отправке. Попробуйте ещё раз.
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={status === 'sending'}
                    className="w-full bg-[#C5A880] hover:bg-[#B39770] disabled:opacity-60 text-white py-4 px-4 sm:px-6 rounded-xl font-semibold text-sm sm:text-base font-['Montserrat'] transition-all duration-300 hover:scale-[1.02] cursor-pointer leading-snug"
                  >
                    {status === 'sending' ? 'Отправка...' : (
                      <span className="flex items-center justify-center gap-2">
                        <span>Записаться на консультацию</span>
                        <i className="ri-arrow-right-line flex-shrink-0"></i>
                      </span>
                    )}
                  </button>

                  <p className="text-white/40 text-xs text-center font-['Montserrat']">
                    Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности
                  </p>
                </form>
              )}
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}
